import { PROPERTY_TYPES } from '../actions/types';

// HO-HU-37: cual property esta activa para una cuenta "property" con mas
// de una propiedad vinculada. Mismo patron que condominiumReducer.jsx (el
// selector de condominio del manager).
const initialState = {
    selectedProperty: null,
    propertyLabel: null,
}

export default function propertyReducer(state = initialState, action) {
    switch (action.type) {
        case PROPERTY_TYPES.SELECT_PROPERTY:
            return {
                ...state,
                selectedProperty: action.payload.id,
                propertyLabel: action.payload.label,
            };
        // HO-ISSUE-119: el inmueble se renombro desde "Mi perfil". Solo cambia
        // la etiqueta que se muestra: la propiedad seleccionada es la misma.
        case PROPERTY_TYPES.RENAME_SELECTED_PROPERTY:
            return {
                ...state,
                propertyLabel: action.payload.label,
            };
        case PROPERTY_TYPES.UNSELECT_PROPERTY:
            return {
                ...state,
                selectedProperty: null,
                propertyLabel: null,
            };
        default:
            return state;
    }
}
